export const AXIOS_DEFAULT_CONFIG = {
  baseURL: process.env.REACT_APP_RECOM_API_URL,
};
